import WithRender from "../../templates/buttons/uploadButton.html";
import { mapActions, mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getShowUpload",
      "getForceDisablePersonalization",
      "getProductPartsNames"
    ]),
    name: function () {
      return this.getShowUpload ? "Cancel uploading" : "Upload";
    }
  },
  methods: {
    ...mapActions(["setShowUpload"]),
    onToggleUpload: function () {}
  },
  watch: {
    getForceDisablePersonalization: {
      handler: function (newValue, oldVal) {
        if (newValue != oldVal && newValue) {
          var pps = this.getProductPartsNames;
          pps.forEach(pp => {
            this.$store.dispatch("uploadOnDelete", pp.code);
          });
        }
      },
      deep: true
    }
  }
});
